import { api } from '@/services';
import type { CreditoDaNotaResponse } from '../types';

export const fetchCreditoDaNota = (chaveAcesso: string) =>
  api.get<CreditoDaNotaResponse>(
    `TurboPro/CreditoIbsCbs/Nota?chaveAcesso=${encodeURIComponent(chaveAcesso)}`
  );
